'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCancelOutline = function TiCancelOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 34.2c-7.8 0-14.2-6.4-14.2-14.2s6.4-14.2 14.2-14.2c7.8 0 14.2 6.4 14.2 14.2s-6.4 14.2-14.2 14.2z m0-25c-6 0-10.8 4.8-10.8 10.8s4.8 10.8 10.8 10.8 10.8-4.8 10.8-10.8-4.8-10.8-10.8-10.8z m0 5c3.2 0 5.8 2.6 5.8 5.8 0 0.3 0 0.7-0.1 1l-6.7-6.7c0.3-0.1 0.7-0.1 1-0.1z m0-1.7c-1.5 0-2.8 0.4-4 1.2l10.3 10.3c0.8-1.2 1.2-2.5 1.2-4 0-4.1-3.4-7.5-7.5-7.5z m-5.7 6.5l6.7 6.7c-0.3 0.1-0.7 0.1-1 0.1-3.2 0-5.8-2.6-5.8-5.8 0-0.3 0-0.7 0.1-1z m-0.6-3c-0.8 1.2-1.2 2.5-1.2 4 0 4.1 3.4 7.5 7.5 7.5 1.5 0 2.8-0.4 4-1.2l-10.3-10.3z' })
        )
    );
};

exports.default = TiCancelOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/cancel-outline.js
// module id = 2001
// module chunks = 0